import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import FileEntry from './file-entry';
import FileEntryDetail from './file-entry-detail';
import FileEntryUpdate from './file-entry-update';
import FileEntryDeleteDialog from './file-entry-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FileEntryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FileEntryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FileEntryDetail} />
      <ErrorBoundaryRoute path={match.url} component={FileEntry} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={FileEntryDeleteDialog} />
  </>
);

export default Routes;
